import { FC, useEffect } from 'react';

import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router';

import { safeSessionStorage } from '../../helpers/utils/safeStorage';
import { showErrorMessage } from '../../helpers/utils/ui';
import { profileApi } from '../../shared/common/api/endpoints/profileApi';
import { endImpersonation } from '../../shared/common/components/header/Header';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import { routeNames } from '../../shared/common/constants/routes';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';

const { Title, Paragraph } = Typography;

// Страница обязательной привязки: пользователь выбирает один мессенджер — Telegram или MAX.
// Маршрут остался прежним (/users/telegram), чтобы не ломать сохранённые ссылки.
const TelegramConnect: FC = () => {

    const navigate = useNavigate();
    const messenger_connect = useTypedSelector((state) => state.currentUser.messenger_connect);

    const handleTelegramClick = () => {

        profileApi
            .getConnectTelegramLink()
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = response.data.telegram_url;
                }
            })
            .catch(() => {
                showErrorMessage(
                    'Ошибка при получении ссылки. Повторите попытку позже.'
                );
            });
    };

    const handleMaxClick = () => {

        profileApi
            .getConnectMaxLink()
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = response.data.max_url;
                }
            })
            .catch(() => {
                showErrorMessage(
                    'Ошибка при получении ссылки на MAX. Повторите попытку позже.'
                );
            });
    };

    useEffect(() => {
        if (messenger_connect) {

        const link = safeSessionStorage.getItem('activeLink') ?? routeNames.overview;
            navigate(link);
        }
    }, [ messenger_connect ]);

    return (
        <MainLayout pageTitle="Привязка мессенджера">
    <div style={{ padding: '24px' }}>
        <Title level={2}>Привяжите мессенджер, чтобы продолжить</Title>
        <Paragraph>
            Достаточно одного. В Telegram приходят уведомления и отчёты, MAX — для связи
            с поддержкой. Второй мессенджер можно привязать позже в профиле.
        </Paragraph>
        <div>
            <Button
                type="primary"
                onClick={handleTelegramClick}
            >
                Привязать Telegram
            </Button>
            <Button
                style={{ marginLeft:'20px' }}
                type="primary"
                onClick={handleMaxClick}
            >
                Привязать MAX
            </Button>
            {localStorage.getItem('access_admin') && <Button style={{ marginLeft:'20px' }} type={'primary'} onClick={()=>endImpersonation()}>Выйти из пользователя</Button>}
        </div>
    </div>
        </MainLayout>
    );
};

export default TelegramConnect;
